/* eslint-disable react/prop-types */
// import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import querySearch from '@/lib/wp/search/querySearch';
import BlockArticleCard from '@/components/BlockArticleCard';
import { useState, useEffect, useRef } from 'react';
import Button from '@/components/Button';
import SearchIcon from '../Header/svg/Search';
import styles from './SearchResults.module.scss';

/**
 * Render a FeatureFull variation of a card
 *
 * @param  {object}  props       component attributes
 * @param  {object}  props.query graphql post data
 * @return {Element}             SearchResults
 */
export default function SearchResults({ query }) {
  const [results, setResults] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [variables, setVariables] = useState({ query, first: 10});
  const [inputValue, setInputValue] = useState(query);
  const paginationRef = useRef(null);
  const form = useRef(null);

  const handleKeypress = (e) => {
    if (e.keyCode === 13) form.current.submit();
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  const { error } = useQuery(querySearch, { variables, onCompleted: (loadedData) => {
    const resultsClone = [...results, ...loadedData?.contentNodes?.edges];
    setResults(resultsClone);
    paginationRef.current = loadedData?.contentNodes?.pageInfo;
    setLoadingMore(false);
  } });

  if (error) {
    return <div>Error: {JSON.stringify(error.message)}</div>;
  }

  const loadPosts = () => {
    setLoadingMore(true);
    setVariables({...variables, after: paginationRef.current?.endCursor});
  };

  return (
    <div>
      <div className={styles.search__header}>
        <h2 className={styles.search__label}><span>Search results for:</span></h2>
        <form className={styles.form} method="get" action="/search" ref={form}>
          <SearchIcon className={styles.search} />
          <input 
            className={styles.search__input} 
            name="q" 
            type="text" 
            placeholder="Search" 
            value={inputValue} 
            onChange={handleChange} 
            onKeyPress={handleKeypress}
            autocomplete="off"
          />
        </form>
      </div>
      <div className={styles.article__cards_title}>
        <h2>Top Results</h2>
      </div>
      <div>
        {results.map((item) => (
          <BlockArticleCard
            key={item?.node?.databaseId}
            postData={item?.node}
            postID={item?.node?.databaseId}
            postType={item?.node?.contentType?.node?.graphqlSingleName}
            cardType="list"
            columnSpan={6}
          />
        ))}
      </div>
      {paginationRef.current?.hasNextPage && (
        <Button onClick={loadPosts} disabled={loadingMore} text={loadingMore ? 'Loading...' : 'Load More'} />
      )}
    </div>
  );
}
